export default class ShareButton {
    static init() {
        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            return;
        }

        window.addEventListener('click', (e) => {
            let shareButton = e.target.closest('.share-button');
            if (shareButton) {
                e.preventDefault();
                ShareButton.share(shareButton);
            }
        });
    }

    static share(shareButton) {
        navigator.share({
                title: shareButton.getAttribute('data-share-title'),
                text: shareButton.getAttribute('data-share-excerpt'),
                url: shareButton.getAttribute('data-share-link'),
            },
            {
                // change this configurations to hide specific unnecessary icons
                copy: true,
                email: true,
                print: false,
                sms: true,
                messenger: true,
                facebook: true,
                whatsapp: true,
                twitter: true,
                linkedin: true,
                telegram: false,
                skype: true,
                pinterest: true,
                language: 'de' // specify the default language
            }
        )
            .catch(error => console.log('Share problem:', error));
    }
}
